<template>
    <div
        class="CSpinner rounded-full"
        :class="{
            'size-6': props.size === 'large',
            'size-3.5': props.size === 'normal',
            'size-12': props.size === 'xlarge'
        }"
    ></div>
</template>

<script setup lang="ts">
type SpinnerSize = 'large' | 'normal' | 'xlarge'

const props = withDefaults(
    defineProps<{
        size?: SpinnerSize
    }>(),
    {
        size: 'normal'
    }
)
</script>

